import { getTemplateNavHeaderStyles } from './NavHeader.styles'
const t = document.createElement('template')
t.innerHTML = `
<div class="search-icon-button">
  <slot></slot>
</div>
`
class NavHeaderUtilitySearchButton extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilitySearchButton connectedCallback', this)
  }
  static get observedAttributes() {
    return ['search-visible']
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'search-visible') {
      console.log('NavHeaderUtilitySearchButton attributeChangedCallback', name, oldValue, newValue)
    }
  }
}

if (!customElements.get('ts-navheader-utility-search-button')) {
  customElements.define('ts-navheader-utility-search-button', NavHeaderUtilitySearchButton)
}
export { NavHeaderUtilitySearchButton }
